// Firebase configuration
export const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyBR1e-dUJOfVbUoUub2Vx3Ixr1eN7P53Ro",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "paiperfb.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "paiperfb",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "paiperfb.appspot.com",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "1018335918224",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:1018335918224:web:43b85bc246a8ad39e78015"
};

// Other API configuration can be added here
export const apiBaseUrl = "https://api.paiperclip.com";